import React, {createContext, useCallback, useEffect, useState} from "react";
import PropTypes from "prop-types";
import MemberService from "../sevices/MemberService";
import LoadingComponent from "../../forms/components/LoadingComponent/LoadingComponent";

export const AuthContext = createContext({member: null, refreshMember: () => {}});

const MemberContainer = (props) => {
  const [member, setMember] = useState();

  const loadMember = useCallback(() => {
    MemberService.getCurrentMember().then(currentMember => {
      setMember(currentMember);
    });
  }, [])

  useEffect(() => {
    loadMember();
  }, []);

  console.log('member', member);
  return member ? (
    <AuthContext.Provider value={{member, refreshMember: loadMember}}>{props.children}</AuthContext.Provider>
  ) : <LoadingComponent isVisible={true} />;
};

MemberContainer.propTypes = {
  children: PropTypes.node.isRequired,
}

export default MemberContainer;